export enum UserIdentityStatusEnum
{
    New = "NEW",
    Pending = "PENDING",
    Active = "ACTIVE",
    Outdated = "OUTDATED",
    Cancelled = "CANCELLED",
    Deleted = "NO_ACTIVO",
    External = "EXTERNAL",
    // Recibido por cesión aprobada y pendiente de que su nuevo propietario la acepte: no es operable.
    Transfer = "TRANSFER"
}